<template>
  <div v-if="vilocalType" class="vilocal-order-tag">
    <div v-if="vilocalType === 1">Free trial</div>
    <div v-if="vilocalType === 2">Free returns</div>
    <div v-if="vilocalType === 3">Free trial with Free returns</div>
    <div v-if="vilocalType === 4">{{ (skuDetailArr&&skuDetailArr.length>0)?(Number(1-skuDetailArr[0].discountTrialRate)*100).toFixed(0):0 }}% off trial</div>
  </div>
</template>

<script>
export default {
  props: {
    vilocalType: {
      type: Number,
      default: null
    },
    skuDetailArr:{
      type: Array,
      default(){
        return []
      }
    }

  }
}
</script>

<style lang="less" scoped>
.vilocal-order-tag{
  max-width: 180px;
  width: auto;
  height: 20px;
  div{
    padding: 5px;
    background-color: #F3E93D;
    border-radius:3px;
    color:#262613;
    font-size: 12px;
    font-family: Satoshi-Medium;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/components/vilocal-order-tag.vue